import ProfileComponent from "../components/Profile/Profile";

export default function Profile({
  openLogOut,
  setOpenLogOut,
  user,
  setUser,
  setOpenBurger,
  cart,
  setCart,
  setOpenLogin,
  showMessage,
  setShowMessage,
  showCopyMessage,
  setShowCopyMessage,
  showDeletedMessage,
  setShowDeletedMessage
}) {
  return (
    <ProfileComponent
      openLogOut={openLogOut}
      setOpenLogOut={setOpenLogOut}
      user={user}
      setUser={setUser}
      setOpenBurger={setOpenBurger}
      cart={cart}
      setCart={setCart}
      setOpenLogin={setOpenLogin}
      showMessage={showMessage}
      setShowMessage={setShowMessage}
      showCopyMessage={showCopyMessage}
      setShowCopyMessage={setShowCopyMessage}
      showDeletedMessage={showDeletedMessage}
      setShowDeletedMessage={setShowDeletedMessage}
    ></ProfileComponent>
  );
}
